import React from "react";
import { Message } from "../types";
import { formatNeuralTime, getInitials, roleLabel } from "../utils/routes";
import {
  Avatar, BodyText, LoadOlderButton, MessageActions, MessageBody, MessageHeader,
  MessageRow, Messages, ReplyQuote, RoleBadge, TinyButton, MutedText, NewMessageButton,
} from "../styles";

type Props = {
  messages: Message[];
  loading: boolean;
  loadingOlder: boolean;
  hasOlder: boolean;
  onLoadOlder: () => void;
  onReply: (message: Message) => void;
  onJumpToBottom: () => void;
  showNewMessage: boolean;
  containerRef: React.RefObject<HTMLDivElement | null>;
};

export const MessageList: React.FC<Props> = ({ messages, loading, loadingOlder, hasOlder, onLoadOlder, onReply, onJumpToBottom, showNewMessage, containerRef }) => (
  <Messages ref={containerRef} aria-live="polite">
    {hasOlder && <LoadOlderButton type="button" onClick={onLoadOlder} disabled={loadingOlder}>{loadingOlder ? "불러오는 중…" : "이전 메시지 불러오기"}</LoadOlderButton>}
    {loading && !messages.length && <MutedText>메시지를 불러오는 중…</MutedText>}
    {!loading && !messages.length && <MutedText>첫 메시지를 남겨 보세요.</MutedText>}
    {messages.map((message) => {
      const reply = message.reply_to ? messages.find((candidate) => candidate.id === message.reply_to) : undefined;
      return (
        <MessageRow key={message.id}>
          <Avatar $kind={message.sender.kind} $small>{getInitials(message.sender.display_name)}</Avatar>
          <MessageBody>
            <MessageHeader><strong>{message.sender.display_name}</strong><RoleBadge $kind={message.sender.kind}>{roleLabel(message.sender.role)}</RoleBadge>{message.message_type === "TASK_REQUEST" && <RoleBadge $task>Task</RoleBadge>}<time dateTime={message.created_at}>{formatNeuralTime(message.created_at)}</time></MessageHeader>
            {reply && <ReplyQuote type="button" onClick={() => document.getElementById(`message-${reply.id}`)?.scrollIntoView({ behavior: "smooth", block: "center" })}><strong>{reply.sender.display_name}</strong> · {reply.body.slice(0, 120)}</ReplyQuote>}
            <BodyText id={`message-${message.id}`}>{message.body}</BodyText>
            {message.message_type !== "SYSTEM" && <MessageActions><TinyButton type="button" onClick={() => onReply(message)}>답장</TinyButton></MessageActions>}
          </MessageBody>
        </MessageRow>
      );
    })}
    {showNewMessage && <NewMessageButton type="button" onClick={onJumpToBottom}>새 메시지 보기</NewMessageButton>}
  </Messages>
);
